module.exports = __webpack_public_path__ + "img/icon_medal_normal.7b5c06d5.png";